<template>
    <v-content style="background-color: #E5E5E5;">
        <v-layout style="min-height: 100vh">
            <v-flex shrink style="background-color: #FFF">
                <SideBar></SideBar>
            </v-flex>
            <v-flex>
                <router-view></router-view>
            </v-flex>
        </v-layout>
        <Footer type="website"></Footer>
    </v-content>
</template>

<script>
    import Footer from "../components/Footer";
    import SideBar from "../components/SideBar";

    export default {
        name: "main-layout",
        components: {
            SideBar,
            Footer
        }
    }
</script>

<style scoped>

</style>